import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {RESOURCES as reportsResources} from '../fuseReportsResourceMap';
import LocationFilter from './LocationFilter';
import {sortArrayByKey} from '../shared/functions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {filterStyles} from '../shared/styles-filter';
import Config from '../messages';

/**
 * A form containing a SelectInput component with Mode choices
 *
 */
class InventoryLogReportsFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null,
            zeroDaysList: [],
            locationsList: [],
            selectedLocation: null,
            selectedZeroDay: null,
        };
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
        this.setLocationList = this.setLocationList.bind(this);
    }

    /* API Calls ------------------------------ */

    /**
     * Get Zero Day results for Date Range options based on selected Location ID
     *
     * @param locationId
     */
    fetchZeroDays(locationId) {
        const params = {
            filter: {},
            location_id: locationId.toString(),
            pagination: {page: 1, perPage: 10000},
            sort: {field: "zero_day", order: "ASC"}
        };
        const resource = reportsResources.ZeroDays.GET_LIST(params);

        // Retrieve the data and assign results to the Select choices
        import('../shared/serverFunctions')
            .then(functions => {

                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }

                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        this.processZeroDaysData(result.data.payload);
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                    } else if (error.request) {
                        // No response
                    } else {
                        console.log('Error', error.message);
                    }
                    this.setState({
                        errorMessage: Config.fuse.error.error + ' Zero Days.'
                    });
                });
            });
    }

    /* Data Processing ------------------------------ */

    /**
     * Process Zero Day results and select the latest
     *
     * @param list
     */
    processZeroDaysData(list) {
        if (list && list.length > 0) {
            let sortedArray = sortArrayByKey(list, 'zero_day', 'DESC');
            let selectedZeroDayItem = sortedArray[0];
            let selectedZeroDay = selectedZeroDayItem['zero_day'].toString();

            this.setState({
                errorMessage: null,
                selectedZeroDay: selectedZeroDay,
                zeroDaysList: list
            }, () => {
                this.props.onSelectZeroDay('zero_day', selectedZeroDay);
            });
        } else {
            this.setState({
                errorMessage: 'There are no Zero Days for the selected Location.',
            });
        }
    }

    /**
     * Store Locations sent by Location Filter
     *
     * @param list
     */
    setLocationList(list) {
        this.setState({
            locationsList: list
        });
    }

    /**
     * Handle selection event for Location
     *
     * @param event
     * @param index
     * @param value
     */
    handleLocationSelect(event, index, value) {
        if (index && index !== value) {
            // Extract the full Location object from the selected location_id
            const locationObj = this.state.locationsList.find(n => n.id.toString() === index.toString());
            if (locationObj) {
                this.setState({
                    selectedLocation: locationObj,
                    selectedZeroDay: null,
                }, () => {
                    this.props.onSelectLocation('location', locationObj);
                });
            }
            this.fetchZeroDays(index);
        }
    }

    render() {
        const {
            errorMessage
        } = this.state;

        const styles = {
            fieldInstructions: {margin: '2em 0 0 0'},
        };

        return (
            <div className="list-filter">
                <p style={styles.fieldInstructions}>Select a Location to begin report generation:</p>
                <LocationFilter
                    label="Select a Location:"
                    onLocationsLoaded={this.setLocationList}
                    onSelectLocation={this.handleLocationSelect}
                    selectionType="id"
                />
                {/* Error and Messaging */}
                {errorMessage &&
                    <div className="error">
                        <p>{errorMessage}</p>
                    </div>
                }
                <hr style={filterStyles.break}/>
            </div>
        );
    }
}

InventoryLogReportsFilter.propTypes = {
    basePath: PropTypes.string,
    onSelectLocation: PropTypes.func,
    onSelectZeroDay: PropTypes.func,
    submitOnEnter: PropTypes.bool,
};

InventoryLogReportsFilter.defaultProps = {
    submitOnEnter: false,
};

const enhance = compose(
    connect()
);

export default enhance(InventoryLogReportsFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/InventoryLogReportsFilter.js